import * as actions from './eStoreTopMenu/actions'
import * as mutations from './eStoreTopMenu/mutations'
import * as getters from './eStoreTopMenu/getters'

import { dataProps } from './eStoreTopMenu/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreTopMenu.js